// extracted by mini-css-extract-plugin
export default {"link":"Link_link__CpfDi","container":"Link_container__sMchS","icon":"Link_icon__k62Rs"};